export default __webpack_public_path__ + "static/media/calasaladeta.fd67b25e.jpg";